<template>
  <div class="home">
    <div  class='ml-5'  v-for='(item,index) in dahsboardValue' :key='index'>
       <h2>Welcome to the NPO Portal for {{item.name}}</h2>
  <v-row>
     
                <v-col md='4' cols="12">
                    <v-card @click='goTo("new")' elevation="5" color="green" max-width="400">
                        <v-list three-line>
                            <v-list-item>
                                <v-list-item-avatar>
                                    <v-icon x-large>mdi-truck-delivery</v-icon>
                                </v-list-item-avatar>
    
                                <v-list-item-content>
                                    <v-list-item-title>Unreceived Donations</v-list-item-title>
                                    <v-list-item-subtitle class="display-2 font-weight-black">{{item.newDonation}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
    
                        </v-list>
    
                    </v-card>
                </v-col>
                <v-col  md='4'  cols="12">
                    <v-card @click='goTo("received")' elevation="5" color="green" max-width="400">
                        <v-list three-line>
                            <v-list-item>
                                <v-list-item-avatar>
                                    <v-icon x-large>mdi-text-box-search-outline</v-icon>
                                </v-list-item-avatar>
    
                                <v-list-item-content>
                                    <v-list-item-title>Unprocessed</v-list-item-title>
                                    <v-list-item-subtitle class="display-2 font-weight-black">{{item.pendingReviewDonations}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
    
                        </v-list>
    
                    </v-card>
                </v-col>
                    <v-col  md='4'  cols="12">
                    <v-card @click='goTo("completed")' elevation="5" color="green" max-width="400">
                        <v-list three-line>
                            <v-list-item>
                                <v-list-item-avatar>
                                    <v-icon x-large>mdi-check-bold</v-icon>
                                </v-list-item-avatar>
    
                                <v-list-item-content>
                                    <v-list-item-title>Completed Donations</v-list-item-title>
                                    <v-list-item-subtitle class="display-2 font-weight-black">{{item.completedReviewDonations}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
    
                        </v-list>
    
                    </v-card>
                </v-col>
                 <v-col  md='4'  cols="12">
                    <v-card @click='goTo("all")' elevation="5" color="green" max-width="400">
                        <v-list three-line>
                            <v-list-item>
                                <v-list-item-avatar>
                                    <v-icon x-large>mdi-package-variant</v-icon>
                                </v-list-item-avatar>
    
                                <v-list-item-content>
                                    <v-list-item-title>Total Donations</v-list-item-title>
                                    <v-list-item-subtitle class="display-2 font-weight-black">{{item.totalDonation}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
    
                        </v-list>
    
                    </v-card>
                </v-col>
                        <v-col  md='4'  cols="12">
                    <v-card @click='goToURL("/donors")' elevation="5" color="green" max-width="400">
                        <v-list three-line>
                            <v-list-item>
                                <v-list-item-avatar>
                                    <v-icon x-large>mdi-account-group</v-icon>
                                </v-list-item-avatar>
    
                                <v-list-item-content>
                                    <v-list-item-title>Total Donors</v-list-item-title>
                                    <v-list-item-subtitle class="display-2 font-weight-black">{{item.totalDonors}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
    
                        </v-list>
    
                    </v-card>
                </v-col>
                 <v-col  md='4'  cols="12">
                    <v-card  elevation="5" color="green" max-width="400">
                        <v-list three-line>
                            <v-list-item>
                                <v-list-item-avatar>
                                    <v-icon x-large>mdi-cash-usd</v-icon>
                                </v-list-item-avatar>
    
                                <v-list-item-content>
                                    <v-list-item-title>Confirmed Balance</v-list-item-title>
                                    <v-list-item-subtitle class="display-2 font-weight-black">${{item.confirmedBalance}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
    
                        </v-list>
    
                    </v-card>
                </v-col>
            </v-row>
    </div>
   
  </div>
</template>

<script>
const fb = require("../../firebaseconfig");
import { mapFields } from "vuex-map-fields";
export default {
  name: 'Home',
    mounted() {
              fb.auth.currentUser.getIdTokenResult(true).then((idTokenResult) => {
            this.npoId = idTokenResult.claims.npo;
            if (!idTokenResult.claims.id) {
                alert("Unauthorize access");
                fb.auth.signOut();
            }
            this.updateDashboard();
        })
  },
  methods : {
      goToURL(url){
          this.$router.push(url);
      },
     goTo(status){
                       this.$router.push('/npoDonations?status=' + status)

        },
            updateDashboard() {

                fb.db.collection("counters").doc("donationList").collection("counters").doc(this.npoId).onSnapshot((data) => {
                    this.dahsboardValue = [];
                    this.dahsboardValue.push(data.data());
                })
        }
  },
  data() {
    return{
      npoId : null,
      dahsboardValue : [],
      ngo : []
    }
  },
  components: {
    
  },
    computed: {
    ...mapFields(["globalRefurbisher"]
    )
  }
}
</script>
